module.exports = __webpack_public_path__ + "img/pro_dis.958bafce.png";